import React from 'react'
import Link from 'next/link'

export default function Pill(props) {
  const {
    children,
    className='',
    bgColor='bg-primary',
    textColor='text-white',
    size='sm',
    href,
  } = props
  const Element = href ? Link : 'div'
  const hoverClasses = href ? `hover:opacity-90` : ''

  let sizeClasses = ''
  let colorClasses = `${textColor} ${bgColor}`

  if (size === 'sm') {
    sizeClasses = 'text-sm px-2 py-1 hover:px-5 '
  } else if (size === 'md') {
    sizeClasses = 'text-md px-4 py-1'
  } else if (size === 'lg') {
    sizeClasses = 'text-lg px-5 py-2'
  } else if (size === 'xs') {
    sizeClasses = 'text-xs px-2 py-1'
  }

  const defaultClasses = 'flex inline-block items-center gap-2 rounded-full transition-all duration-150 text-center'
  const classes = `${className} ${sizeClasses} ${colorClasses} ${hoverClasses} ${defaultClasses}`
  return (
    <Element href={href} className={classes}>
      {children}
    </Element>
  )
}
